import moment from "moment";
import ArrowUpRedIcon from "../assets/images/ArrowUpRed.svg";
import ArrowUpWhiteIcon from "../assets/images/ArrowUpWhite.svg";
import { INotification } from "./Interfaces";

let CryptoJS = require("crypto-js");
let encryptKey = "laka@cant$drive!car3213";

export function saveTokens(token: any, refresh: any) {
  sessionStorage.setItem("jwt", token);
  sessionStorage.setItem("refresh", refresh);
}

export function getTokens() {
  let jwt = sessionStorage.getItem("jwt");
  let refresh = sessionStorage.getItem("refresh");

  return { jwt: jwt, refresh: refresh };
}

export function userEncrypt(user: any) {
  let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(user), encryptKey).toString();
  sessionStorage.setItem("user", JSON.stringify(ciphertext))
}

export function userDecrypt() {
  let ciphertext = JSON.parse(sessionStorage.getItem("user") || "{}");
  let bytes = CryptoJS.AES.decrypt(ciphertext, encryptKey);
  let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return (user)
}

export function divideRoles(roles: string[]) {
  if (roles.length > 1) {
    return roles.map((e: any, i: number, arry: any) => {
      let return_ = arry.length - 1 == i ? "" : "/";
      return e.charAt(0) + return_;
    });
  } else {
    return roles[0];
  }
}

export function removeTokens() {
  sessionStorage.removeItem("jwt");
  sessionStorage.removeItem("refresh");
  sessionStorage.removeItem("user");
  return true;
}

export function getEnvironment() {
  return process.env.REACT_APP_ENV;
}

export function getBaseURL() {

  let env = getEnvironment();

  if (env === "development") {
    return "https://dev.admin.api.infragist.com";
  } else if (env === "staging") {
    return "https://scribe-it-uat-api.t1o6822kgg5sm.ap-southeast-2.cs.amazonlightsail.com"
  } else if (env === "production") {
    return "https://scribe-it-prod-api.t1o6822kgg5sm.ap-southeast-2.cs.amazonlightsail.com"
  } else {
    return "https://localhost:7282"
  }
}

export function getCurrentDimension() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

export function validStringField(value: string) {
  if (value) {
    return value;
  } else {
    return " - "
  }
}

export function validDateField(value: Date) {
  if (value) {
    return moment(value).format("DD-MM-YYYY");
  } else {
    return " - "
  }
}

export function getFileSize(size: string) {
  return (parseFloat(size) / (1024 * 1024)).toFixed(2);
}

export const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
  });

export function isInRole(roles: string[], role: string) {
  if (roles?.length > 0) {
    return roles?.includes(role);
  }
  return false;
}

export function splitWord(word: string | undefined | null) {
  if (!word) {
    return "-"
  }

  let wordArr = word.split(/(?=[A-Z])/);
  let spiltWord = "";

  for (var i = 0; i < wordArr.length; i++) {
    spiltWord += " " + wordArr[i]
  }

  return spiltWord.trim()
}

export function convertDuration(duration: number) {
  if (!isNaN(duration)) {
    return duration >= 3600
      ? new Date(duration * 1000).toISOString().substring(11, 19)
      : new Date(duration * 1000).toISOString().substring(14, 19);
  } else {
    return "00:00";
  }
}


export function obscureEmail(email: string) {

  let obsure = "";

  if (email.trim() !== "") {
    const [name, domain] = email.split("@");
    obsure = `${name[0]}${name[1]}${name[2]}${new Array(name.length - 2).join("*")}@${domain}`;
  }

  return obsure;
};

export function separateRoles(roles: string[]) {
  if (roles?.length > 1) {
    let text = "";

    for (let index = 0; index < roles.length; index++) {
      if (index + 1 === roles.length) {
        text = text + roles[index];
      } else {
        text = text + roles[index] + "/";
      }
    }

    return text;
  } else {
    return roles?.[0];
  }
}

export function convertTo2DecimalPlaces(floatNumber: number) {
  if (!isNaN(floatNumber)) {
    return Number(floatNumber.toString().match(/^\d+(?:\.\d{0,2})?/));
  } else {
    return 0;
  }
}

export async function getDuration(url: any) {
  return new Promise((resolve) => {
    const audio = document.createElement("audio");
    const source = document.createElement("source");
    source.src = url;
    audio.muted = true;
    audio.preload = "metadata";
    audio.appendChild(source);
    audio.onloadedmetadata = function () {
      resolve(audio.duration);
    };
  });
}

export function getPriority(priority: string) {
  if (priority === "S. Urgent") {
    return (<div className="urgency-box dark-red">
      <img className="urgency-icon margin-right" src={ArrowUpWhiteIcon} alt={"Up"} />
      {priority}
    </div>);
  }

  if (priority === "Urgent") {
    return (<div className="urgency-box red">
      <img className="urgency-icon margin-right" src={ArrowUpRedIcon} alt={"Up"} />
      {priority}
    </div>);
  }

  if (priority === "24 Hours") {
    return <div className="urgency-box yellow">{priority}</div>;
  }

  if (priority === "48 Hours") {
    return <div className="urgency-box light-blue">{priority}</div>;
  }

  if (priority === "72 Hours") {
    return <div className="urgency-box dark-blue">{priority}</div>;
  }
}

export function getUrlParams() {

  let urlString = window.location.href;

  let url = new URL(urlString);
  let args = new URLSearchParams(url.search);

  let token = args.get("token") as string;
  let fixedToken = token.replace(/\s/g, "+");

  return { token: fixedToken }
}

export function emailValidation(email: string) {

  let isValid = false;

  if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {
    isValid = true;
  }

  return isValid;
}

export function passwordValidation(password: string) {

  let isValid = false;

  if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(password)) {
    isValid = true;
  }

  return isValid;
}

export function calculateDueDate(numberOfDaysAdded: number) {
  if (numberOfDaysAdded === 0) {
    return moment().utc().local();
  }

  return moment().utc().local().add(numberOfDaysAdded, "days");
}

export function sortRequestedChanges(requestedChanges: any) {

  let dateSorted = requestedChanges?.sort(function (a: any, b: any) {
    return +new Date(b.createdDate) - +new Date(a.createdDate);
  });

  let completed = dateSorted?.filter((t: any) => t.status === "Completed");
  let pending = dateSorted?.filter((t: any) => t.status === "Pending");

  return pending?.concat(completed);
}

export function getTimeDifference(date: Date) {
  const now = moment();
  const diff = moment.duration(now.diff(date));
  const minutes = diff.asMinutes();
  const hours = diff.asHours();

  if (minutes < 60) {
    return Math.round(minutes) + ' min ago';
  } else if (hours <= 24) {
    const roundedHours = Math.round(hours);
    return roundedHours === 1 ? '1 hr ago' : `${roundedHours} hrs ago`;
  } else {
    return validDateField(date);
  }
}

export function sortNotificationsByDate(notifications: INotification[]) {
  return notifications?.sort((a, b) => { return b?.createdDate?.seconds - a?.createdDate?.seconds })
}

export function verifyReportName(props: { fileName: string, reportName: string, reportType: string }) {
  if (props.reportName) {
    return props.reportName;
  } else {
    return `${props.reportType}_${props.fileName}`;
  }
}

export async function getTimeSlots(setTimeSlots: CallableFunction) {

  let x = {
    slotInterval: 30,
    openTime: '00:00',
    closeTime: '23:59'
  };

  let startTime = moment(x.openTime, "HH:mm");
  let endTime = moment(x.closeTime, "HH:mm");

  let allTimes = [];

  while (startTime < endTime) {
    allTimes.push(startTime.toString());
    startTime.add(x.slotInterval, 'minutes');
  }

  allTimes.push(endTime.toString());

  return setTimeSlots(allTimes)
}

export function concatenateDateTime(props: { date: any, time: any }) {
  return moment(props.date.toString().substring(0, 16).concat(props.time.substring(16,)));
}

export function getDateFromTimeStamp(fileId: string) {
  if (fileId) {
    const timestamp = parseInt(fileId.split('_')[0]);
    return moment(timestamp).format("DD-MM-YYYY hh:mm A");
  }

  return "-";
}

export function getFileNameForZip(patientName: string, dateOfAssessment: Date) {
  const assessmentDateObj = dateOfAssessment instanceof Date
    ? dateOfAssessment
    : (dateOfAssessment as any)?.toDate?.() || new Date(dateOfAssessment);

  const day = String(assessmentDateObj.getDate()).padStart(2, '0');
  const month = String(assessmentDateObj.getMonth() + 1).padStart(2, '0');
  const year = assessmentDateObj.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const cleanPatientName = patientName.replace(/\s+/g, '_');
  return `${cleanPatientName}-${formattedDate}.zip`;
}

export function formatMB(value: string): string {
  const toNumber = parseFloat(value);

  if (isNaN(toNumber)) {
    return '0 MB';
  }

  const truncated = Math.floor((toNumber + Number.EPSILON) * 100) / 100;
  return `${truncated} MB`;
}

export function formatLocalISO(date: moment.MomentInput): string {
  return date ? moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS") : "";
}